// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_WorkOrderAssignResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/orders/work_order_assign/{work_order_id}
 *
 * Returns the work order id and the user (Cognito sub) it was assigned to.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_WorkOrderAssignResponseDados {
work_order_id: number
user_id: string
}

export type Orders_WorkOrderAssignResponse = ApiResponse<Orders_WorkOrderAssignResponseDados>;

registerResponseContract('Orders_WorkOrderAssignResponse', {
  work_order_id: { type: 'number',  required: true },
  user_id:       { type: 'string',  required: true },
})
